import React from 'react';
import './PageStyles.css';

const OurStory: React.FC = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Our Story</h1>
        <p>Where Flavor Meets Fun - The Burbanks Experience</p>
      </div>

      <div className="story-container">
        <div className="story-section">
          <div className="story-image">
            <img src="/assets/food/IMG_6171-750x465.jpg" alt="Burbanks Restaurant Interior" />
          </div>
          <div className="story-content">
            <h2>Welcome to Burbanks</h2>
            <p>
              Founded in 2018, Burbanks began as a dream to create a place where exceptional food,
              great music, and genuine hospitality come together. Located in the heart of our community,
              we've become a gathering place for friends, families, and food lovers alike.
            </p>
            <p>
              Our philosophy is simple: use the freshest local ingredients, prepare everything with care,
              and serve it with a smile. From our signature burgers to our craft cocktails, every item
              on our menu is crafted with passion and attention to detail.
            </p>
          </div>
        </div>

        <div className="story-section reverse">
          <div className="story-content">
            <h2>Our Mission</h2>
            <p>
              At Burbanks, we believe that great food brings people together. Our mission is to provide
              an exceptional dining experience that combines delicious, locally-sourced cuisine with
              live entertainment in a warm, welcoming atmosphere.
            </p>
            <p>
              We're committed to supporting our local community through partnerships with nearby farms,
              featuring local musicians, and creating a space where neighbors become friends over
              shared meals and memorable moments.
            </p>
          </div>
          <div className="story-image">
            <img src="/assets/food/IMG_6185-750x465.jpg" alt="Fresh Ingredients" />
          </div>
        </div>

        <div className="team-section">
          <h2>Meet Our Team</h2>
          <div className="team-grid">
            <div className="team-member">
              <div className="member-placeholder">
                <span>👨‍🍳</span>
              </div>
              <h3>Chef Marcus</h3>
              <p>Executive Chef</p>
              <p>With over 15 years of culinary experience, Chef Marcus brings creativity and passion to every dish.</p>
            </div>

            <div className="team-member">
              <div className="member-placeholder">
                <span>👩‍💼</span>
              </div>
              <h3>Sarah Johnson</h3>
              <p>General Manager</p>
              <p>Sarah ensures every guest feels welcome and has an unforgettable experience at Burbanks.</p>
            </div>

            <div className="team-member">
              <div className="member-placeholder">
                <span>🍹</span>
              </div>
              <h3>Mike Rodriguez</h3>
              <p>Head Bartender</p>
              <p>Mike crafts our signature cocktails and curates our extensive beverage program.</p>
            </div>
          </div>
        </div>

        <div className="values-section">
          <h2>Our Values</h2>
          <div className="values-grid">
            <div className="value-item">
              <h3>🌱 Fresh & Local</h3>
              <p>We source ingredients from local farms and suppliers whenever possible.</p>
            </div>
            <div className="value-item">
              <h3>🎵 Community</h3>
              <p>We support local musicians and create space for community gathering.</p>
            </div>
            <div className="value-item">
              <h3>❤️ Hospitality</h3>
              <p>Every guest is treated like family with genuine care and attention.</p>
            </div>
            <div className="value-item">
              <h3>🌟 Quality</h3>
              <p>We never compromise on the quality of our food, drinks, or service.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurStory; 